// export const apiURL = 'https://arsen.com.br/api/v1';
export const apiURL = "https://fasttrack.omnibrasil.com.br/api/api/v1";
